import * as Types from './types';

export function setSelectedCompany(selectedCompany?: Company) {
  return {
    type: Types.ActionTypes.SET_SELECTED_COMPANY,
    selectedCompany
  }
}